import { Component, input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";

import { SharedModule } from "../shared.module";

@Component({
  selector: "app-contact-section",
  standalone: true,
  imports: [TranslatePipe, SharedModule],
  templateUrl: "./contact-section.component.html",
})
export class ContactSectionComponent {
  parentFormGroup = input.required<FormGroup>();
  category = input.required<string>();
}
